<template>
  <nav id="sidebar" aria-label="Main Navigation">
    <!-- Side Header -->
    <div class="content-header bg-white-5">
      <!-- Logo -->

        <multiselect
          v-if="clients.length > 1"
          style="max-width: 300px"
          :allow-empty="false"
          track-by="uuid"
          select-label=""
          deselect-label=""
          selected-label=""
          class="organisation-select flex-grow-1"
          :custom-label="(option) => option.name"
          :placeholder="$t('search')"
          v-model="currentClient"
          :options="clients"
        >
        </multiselect>
      <router-link v-if="clients.length === 1" class="font-w600 text-dual" :to="homeRoute">
         {{ currentClient.name }}
      </router-link>
      <!-- END Logo -->

      <!-- Options -->
      <div>
        <!-- Close Sidebar, Visible only on mobile screens -->
        <!-- Layout API, functionality initialized in Template._uiApiLayout() -->
        <a class="d-lg-none text-dual ml-3" @click="closeNav()" href="javascript:void(0)">
          <i class="fa fa-times"></i>
        </a>
        <!-- END Close Sidebar -->
      </div>
      <!-- END Options -->
    </div>
    <!-- END Side Header -->

    <!-- Side Navigation -->
    <div class="content-side content-side-full">
      <ul class="nav-main">
          <li class="nav-main-item" v-if="$store.getters.isExternalScorekeeper">
            <router-link class="nav-main-link" :to="{name:'enterTheGame'}">
              <i class="nav-main-link-icon fa fa-sign-in"></i>
              <span class="nav-main-link-name">{{ $t('navbar.enterTheGame') }}</span>
            </router-link>
          </li>
          <li class="nav-main-item" v-if="$store.getters.isAdminOrInternalScorekeeper">
            <router-link class="nav-main-link" :to="{name:'games'}">
              <i class="nav-main-link-icon fa fa-list"></i>
              <span class="nav-main-link-name">{{ $t('navbar.games') }}</span>
            </router-link>
          </li>
          <li class="nav-main-item" v-if="$store.getters.isAdminOrInternalScorekeeper || $store.getters.isMediaManager">
            <router-link class="nav-main-link" :to="mediaRoute">
              <i class="nav-main-link-icon fa fa-video-camera"></i>
              <span class="nav-main-link-name">Livestream</span>
            </router-link>
          </li>
          <li class="nav-main-item"  v-if="$store.getters.isAdminOrInternalScorekeeper || $store.getters.isMediaManager">
            <router-link class="nav-main-link" :to="{name:'photos'}">
              <i class="nav-main-link-icon fa fa-camera"></i>
              <span class="nav-main-link-name">{{ $t('navbar.gamePhotos') }}</span>
            </router-link>
          </li>
          <li class="nav-main-item"  v-if="$store.getters.isAdminOrInternalScorekeeper || $store.getters.isMediaManager">
            <router-link class="nav-main-link" :to="{name:'playerPhotos'}">
              <i class="nav-main-link-icon fa fa-user-circle-o"></i>
              <span class="nav-main-link-name">{{ $t('navbar.playerPhotos') }}</span>
            </router-link>
          </li>
      </ul>
    </div>
    <!-- END Side Navigation -->
  </nav>
</template>

<script>
import router from '@/router'
import { routeAfterGame } from '@/use/useStartPage'
import Multiselect from 'vue-multiselect'

export default {
  components: { Multiselect },
  computed: {
    // the logo / organisation name: the code page for the external scorekeeper, the games for everybody else
    homeRoute () {
      return routeAfterGame(this.$store)
    },
    mediaRoute () {
      return {
        name: 'livestream',
        params: { clientId: this.currentClient.uuid },
        query: {
          tab: 'venues'
        }
      }
    },
    currentClient: {
      get () {
        return this.$store.state.currentClient
      },
      async set (value) {
        await this.$store.dispatch('setClient', value)
        this.$router.push('/')
      }
    },
    clients () {
      return this.$store.state.user.clients
    },
    user () {
      return this.$store.state.user
    }
  },
  methods: {
    goToRoute (route) {
      router.push(route)
    },
    closeNav () {
      this.$store.dispatch('closeNav')
    }
  }
}
</script>
